export default __webpack_public_path__ + "static/media/beheer.1b6674c6.svg";